import React, { useEffect, useMemo, useState } from "react";
import User from "../api/User";
import { Role } from "../components/admin/Role";
import { UsersAdminPanel } from "../components/admin/UsersAdminPanel";
import { observer } from "mobx-react-lite";
import { Navigate } from "react-router-dom";
import { ClientIdAdmin } from "../components/admin/client_id/ClientIdAdmin";
import { ProductionAuditPanel } from "../components/admin/productionAudit/ProductionAuditPanel";
import RolesState from "../api/RolesState";

const TAB_USERS = "users";
const TAB_ROLES = "roles";
const TAB_CLIENT_ID = "clientId";
const TAB_PRODUCTION_AUDIT = "productionAudit";

const AdminPanel = observer(() => {
  const usersRights =
    User.user.permission.includes("post_user") || User.user.is_superuser;
  const rolesRights =
    User.user.permission.includes("patch_permission_id") ||
    User.user.is_superuser;
  const clientIdRights =
    User.user.permission.includes("patch_client_id") ||
    User.user.is_superuser;
  const productionAuditRights = User.user.is_superuser;

  const defaultTab = useMemo(() => {
    if (usersRights) return TAB_USERS;
    if (rolesRights) return TAB_ROLES;
    if (clientIdRights) return TAB_CLIENT_ID;
    if (productionAuditRights) return TAB_PRODUCTION_AUDIT;
    return null;
  }, [usersRights, rolesRights, clientIdRights, productionAuditRights]);

  const [activeTab, setActiveTab] = useState(defaultTab);

  useEffect(() => {
    setActiveTab(defaultTab);
  }, [defaultTab]);

  if (!RolesState.admin_panel) {
    return <Navigate to="/noright" />;
  }

  const tabClass = (tab) =>
    `tab-item${activeTab === tab ? " active" : ""}`;

  return (
    <div className="main-page company-card-v4 admin-panel-v4">
      <header className="card header-card admin-panel-header">
        <div className="header-top">
          <div className="company-title">
            <div className="compamy-title-name-container">
              <span className="req-label">Администрирование</span>
              <h1>Панель администратора</h1>
            </div>
          </div>
        </div>
      </header>

      <nav
        className="navigation-tabs admin-panel-tabs"
        role="tablist"
        aria-label="Разделы панели администратора"
      >
        {usersRights ? (
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === TAB_USERS}
            className={tabClass(TAB_USERS)}
            onClick={() => setActiveTab(TAB_USERS)}
          >
            Пользователи
          </button>
        ) : null}
        {rolesRights ? (
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === TAB_ROLES}
            className={tabClass(TAB_ROLES)}
            onClick={() => setActiveTab(TAB_ROLES)}
          >
            Роли
          </button>
        ) : null}
        {clientIdRights ? (
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === TAB_CLIENT_ID}
            className={tabClass(TAB_CLIENT_ID)}
            onClick={() => setActiveTab(TAB_CLIENT_ID)}
          >
            Клиенты ИД
          </button>
        ) : null}
        {/* {productionAuditRights ? (
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === TAB_PRODUCTION_AUDIT}
            className={tabClass(TAB_PRODUCTION_AUDIT)}
            onClick={() => setActiveTab(TAB_PRODUCTION_AUDIT)}
          >
            Площадки / аудит
          </button>
        ) : null} */}
      </nav>

      <div className="admin-panel-tab-panel" role="tabpanel">
        {activeTab === TAB_USERS ? <UsersAdminPanel /> : null}
        {activeTab === TAB_ROLES ? <Role /> : null}
        {activeTab === TAB_CLIENT_ID ? <ClientIdAdmin /> : null}
        {activeTab === TAB_PRODUCTION_AUDIT ? <ProductionAuditPanel /> : null}
      </div>
    </div>
  );
});
export { AdminPanel };
